import React, { useState } from "react";
import { API_BASE, authHeaders, useAgency } from "./AgencyContext";

const G = "#0077B5";

export default function AgencySettings() {
  const { agency, refresh } = useAgency();
  const [brandName, setBrandName] = useState(agency?.brand_name || "");
  const [logoUrl, setLogoUrl] = useState(agency?.logo_url || "");
  const [primaryColor, setPrimaryColor] = useState(agency?.primary_color || "#0077B5");
  const [domain] = useState(agency?.domain || "");
  const [emailDomain] = useState(agency?.email_domain || "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    setSaving(true); setSaved(false);
    try {
      // Agency settings are updated via admin endpoint — agency owner calls it
      // through the agency auth flow which patches via admin internally
      const r = await fetch(`${API_BASE}/app/api/admin/agencies/${agency.id}`, {
        method: "PATCH", headers: { ...authHeaders(), "X-Admin-Key": "" },
        body: JSON.stringify({ brand_name: brandName, logo_url: logoUrl, primary_color: primaryColor }),
      });
      if (r.ok) { setSaved(true); refresh(); }
    } catch {}
    setSaving(false);
  };

  return (
    <div>
      <div style={{ fontSize: 22, fontWeight: 500, marginBottom: 20 }}>Settings</div>

      <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 24, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 16 }}>Branding</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <div>
            <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>Brand name</label>
            <input value={brandName} onChange={e => setBrandName(e.target.value)} style={{ width: "100%", padding: "10px 12px", borderRadius: 6, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>Logo URL</label>
            <input value={logoUrl} onChange={e => setLogoUrl(e.target.value)} placeholder="https://..." style={{ width: "100%", padding: "10px 12px", borderRadius: 6, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>Primary color</label>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input type="color" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} style={{ width: 40, height: 36, border: "none", borderRadius: 4, cursor: "pointer" }} />
              <input value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} style={{ flex: 1, padding: "10px 12px", borderRadius: 6, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, boxSizing: "border-box" }} />
            </div>
          </div>
          <div>
            {logoUrl && (
              <div>
                <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>Preview</label>
                <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", background: "#f3f2ef", borderRadius: 8 }}>
                  <img src={logoUrl} alt="" width="32" height="32" style={{ borderRadius: 6 }} onError={e => { e.target.style.display = "none"; }} />
                  <span style={{ fontSize: 14, fontWeight: 600, color: primaryColor }}>{brandName}</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <button onClick={save} disabled={saving} style={{ marginTop: 16, background: G, color: "#fff", border: "none", borderRadius: 6, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer", opacity: saving ? 0.6 : 1 }}>
          {saving ? "Saving…" : "Save branding"}
        </button>
        {saved && <span style={{ marginLeft: 12, fontSize: 13, color: "#1D9E75" }}>Saved</span>}
      </div>

      {/* Domain config */}
      <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 24, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Custom domain</div>
        <div style={{ fontSize: 13, color: "#555", marginBottom: 8 }}>
          Current: <strong>{domain || "Not configured"}</strong>
        </div>
        <div style={{ background: "#f3f2ef", borderRadius: 8, padding: 14, fontSize: 12, color: "#555", lineHeight: 1.6 }}>
          To use a custom domain, add this DNS record:<br />
          <code style={{ background: "#fff", padding: "2px 6px", borderRadius: 4 }}>CNAME app → my.brandhives.com</code><br /><br />
          Then contact BrandHives support to activate it. Domain changes require manual CF Worker route setup.
        </div>
      </div>

      {/* Email domain */}
      <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Email domain</div>
        <div style={{ fontSize: 13, color: "#555", marginBottom: 8 }}>
          Current: <strong>{emailDomain || "brandhives.com (default)"}</strong>
        </div>
        <div style={{ background: "#f3f2ef", borderRadius: 8, padding: 14, fontSize: 12, color: "#555", lineHeight: 1.6 }}>
          To send emails from your domain, add these DNS records:<br />
          <code style={{ background: "#fff", padding: "2px 6px", borderRadius: 4 }}>TXT @ v=spf1 include:send.resend.com ~all</code><br />
          <code style={{ background: "#fff", padding: "2px 6px", borderRadius: 4 }}>CNAME resend._domainkey (provided by Resend)</code><br />
          <code style={{ background: "#fff", padding: "2px 6px", borderRadius: 4 }}>TXT _dmarc v=DMARC1; p=quarantine; ...</code><br /><br />
          Contact BrandHives after adding records to complete verification.
        </div>
      </div>
    </div>
  );
}
